var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunrocketWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0864 11.448L3.32868 21.2059M14.1325 3.78399C15.3835 4.61413 16.586 5.59282 17.7097 6.7165C18.8431 7.84987 19.8289 9.06343 20.6636 10.3261M9.23978 8.25993L6.28692 7.27563C5.94685 7.16228 5.57229 7.23441 5.29864 7.46596L2.36396 9.94917C1.76317 10.4575 1.93386 11.425 2.67235 11.6971L5.45299 12.7215M11.7317 19.0001L12.7561 21.7808C13.0282 22.5193 13.9957 22.69 14.504 22.0892L16.9872 19.1545C17.2188 18.8808 17.2909 18.5062 17.1775 18.1662L16.1933 15.2133M19.6073 2.48184L14.5677 3.32178C14.0235 3.41248 13.5244 3.67995 13.1475 4.08283L6.35498 11.3438C4.59432 13.2259 4.64329 16.1652 6.46568 17.9876C8.28807 19.81 11.2273 19.859 13.1094 18.0983L20.3703 11.3057C20.7732 10.9288 21.0407 10.4297 21.1314 9.88553L21.9713 4.84589C22.203 3.45551 20.9976 2.25011 19.6073 2.48184Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunrocketWhiteIcon);
export default __webpack_public_path__ + "static/media/runrocket-white-icon.57c6ce785052233c8d8cc0399dc6cf83.svg";
export { ForwardRef as ReactComponent };